import { useRouter } from 'next/router'
import { useSession } from 'next-auth/react'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'
import { toast } from 'react-toastify'
import clsx from 'clsx'

import { Button } from 'components/buttons'
import { IconClipboard, IconPDF, IconPrint } from 'icons'

import { loadFile } from 'hooks/useFile/file.service'

import { IPrintCVButtonsProps } from '../CV/types'

const buttonStyle =
  'bg-white/80 px-3 sm:px-5 py-3 font-semibold uppercase transition-colors hover:bg-white/70 active:bg-white/90'

const PrintCVButtons = ({ cvId, className }: IPrintCVButtonsProps) => {
  const { t } = useTranslation('actions')
  const { locale } = useRouter()
  const { data } = useSession()
  const [isLoading, setIsLoading] = useState(false)

  return (
    <div className={clsx(className, 'flex w-full justify-end print:hidden')}>
      <Button
        type="button"
        variant="secondary"
        className={buttonStyle}
        onClick={async () => {
          await navigator.clipboard.writeText(
            `${window.location.host}/cv/${cvId}`
          )
          toast(t('toast.linkCopied', { ns: 'actions' }))
        }}
      >
        <IconClipboard className={'min-w-fit'} />
        {t('copyLink', { ns: 'actions' })}
      </Button>
      <Button
        variant="secondary"
        isLoading={isLoading}
        className={clsx(buttonStyle, 'flex')}
        onClick={async () => {
          setIsLoading(true)
          await loadFile({
            url: `/api/pdf/${cvId}`,
            token: data?.jwt,
            lang: locale
          })
          setIsLoading(false)
        }}
      >
        <IconPDF />
        PDF
      </Button>
      <Button
        onClick={async () =>
          await loadFile({
            url: `/api/pdf/${cvId}`,
            token: data?.jwt,
            lang: locale,
            print: true
          })
        }
        variant="secondary"
        className={buttonStyle}
      >
        <IconPrint />
        {t('print', { ns: 'actions' })}
      </Button>
    </div>
  )
}

export default PrintCVButtons
